import { render, staticRenderFns } from "./doc_viewer.vue?vue&type=template&id=4f49a354&scoped=true"
import script from "./doc_viewer.vue?vue&type=script&lang=js"
export * from "./doc_viewer.vue?vue&type=script&lang=js"
import style0 from "./doc_viewer.vue?vue&type=style&index=0&id=4f49a354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f49a354",
  null
  
)

export default component.exports